






























import { Component, Prop, Vue } from 'vue-property-decorator';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { UserConfModule } from '@/store/modules/userConf';
import TableOfContents from '@/types/TableOfContents';
import { getModule } from 'vuex-module-decorators';
import ProgressTile from '@/components/ProgressTile.vue';
import Accordion from '@/components/Accordion.vue';
import AccordionItem from '@/models/AccordionItem';
import References from '@/components/References.vue';
import Glossary from '@/components/Glossary.vue';
import TocComponent from '@/components/TableOfContents.vue';
import TrainingOptions from '@/components/TrainingOptions.vue';

const AppState = getModule(AppModule, store);
const UserConfState = getModule(UserConfModule, store);

@Component({
  components: {
    Accordion,
    ProgressTile,
    TocComponent,
    References,
    Glossary,
    TrainingOptions
  }
})
export default class Sidebar extends Vue {
  @Prop(String) logo!: string;
  @Prop(Boolean) show!: boolean;

  toc: TableOfContents = AppState.tableOfContents;
  version: string = AppState.getVersion;
  accordionElements = [
    new AccordionItem(
      'fa-list-alt',
      (this as any).$options.filters.localize('Table of Contents'),
      TocComponent
    ),
    new AccordionItem(
      'fa-bars',
      (this as any).$options.filters.localize('Glossary'),
      Glossary
    ),
    new AccordionItem(
      'fa-sticky-note',
      (this as any).$options.filters.localize('References'),
      References
    )
  ];
  public $refs!: {
    closeSidebar: HTMLFormElement;
  };
  get getCurrentIndex(): number {
    return AppState.currentIndex;
  }

  get lightMode(): boolean {
    return UserConfState.lightMode;
  }

  mounted(){
    store.watch(
      () => AppState.getSideBarOpen,
      () => {
        if(AppState.getSideBarOpen){
         setTimeout(()=>{
           this.$refs.closeSidebar.focus()
         },500)
        }
      }
    );
  }
}
